import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./UserManagement.css";
import "../AdminIndex.css";
import { SidebarCol } from "../../chatMain/Sidebar/Sidebar.jsx";
import { MainHeader } from "../../chatMain/MainHeader/MainHeader.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import api from "../../../axiosconfig.js";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { faX } from "@fortawesome/free-solid-svg-icons";
import Papa from "papaparse";
import { isAdminUser } from "../../../utils/userUtils";

export const UserManagement = () => {
  //REACT variables
  const navigate = useNavigate();
  const API_URL = process.env.REACT_APP_API_URL;
  const [activeMode, setActiveMode] = useState(true);

  //Data variables
  const [companyName, setCompanyName] = useState("");
  const [users, setUsers] = useState([]);
  const [entryList, setEntryList] = useState([]);
  const [isSU, setIsSU] = useState(false);
  const [currentRole, setCurrentRole] = useState("Employee");
  const [bulkAdd, setBulkAdd] = useState(false);
  const [bulkUsers, setBulkUsers] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isDeactivating, setIsDeactivating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  //Selected User Variables
  const [selectedActiveUser, setSelectedActiveUser] = useState("");
  const [gridKey, setGridKey] = useState(0);

  //modals
  var addModal = document.getElementById("addModal");
  var editModal = document.getElementById("editModal");

  //inputs
  var newFirstName = document.getElementById("newFN");
  var newLastName = document.getElementById("newLN");
  var newEmail = document.getElementById("newEmail");
  var newRole = document.getElementById("newRole");
  var bulkCSV = document.getElementById("bulkCSV");

  var editFirstName = document.getElementById("editFN");
  var editLastName = document.getElementById("editLN");
  var editEmail = document.getElementById("editEmail");
  var editRole = document.getElementById("editRole");

  //Column setup for table
  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "firstname", headerName: "First Name", width: 150 },
    { field: "lastname", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "role", headerName: "Role", width: 100 },
  ];

  const columnsActive = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "firstname", headerName: "First Name", width: 150 },
    { field: "lastname", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "role", headerName: "Role", width: 100 },
    { field: "status", headerName: "Status", width: 100 },
    { field: "lastlogin", headerName: "Last Login", width: 250 },
  ];

  function setSelected(selected) {
    if (selectedActiveUser && selected.row.id === selectedActiveUser.row.id) {
      setSelectedActiveUser("");
    } else {
      setSelectedActiveUser(selected);
    }
  }

  function handleRemoveTemplate() {
    bulkCSV.value = "";
    setBulkAdd(false);
    setBulkUsers([]);
  }

  function handleEditActive() {
    const editModalEl = document.getElementById("editModal");
    const editFNEl = document.getElementById("editFN");
    const editLNEl = document.getElementById("editLN");
    const editEmailEl = document.getElementById("editEmail");
    const editRoleEl = document.getElementById("editRole");

    if (editModalEl) {
      editModalEl.style.display = "flex";
    }
    if (selectedActiveUser) {
      if (editFNEl) editFNEl.value = selectedActiveUser.row.firstname || "";
      if (editLNEl) editLNEl.value = selectedActiveUser.row.lastname || "";
      if (editEmailEl) editEmailEl.value = selectedActiveUser.row.email || "";
      if (editRoleEl) editRoleEl.value = selectedActiveUser.row.role || "Employee";
    }
  }

  const bulkAddUser = async (user) => {
    if (user.FirstName && user.LastName && user.Email && user.Role) {
      if ((/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(user.Email)) && (user.Role == "Employee" || user.Role == "Admin")) {
        setBulkUsers(bulkUsers => [...bulkUsers, user]);
      } else {
        toast.error(user.FirstName + " " + user.LastName + " was not added. Either their email or role was invalid.")
      }
    } else {
      toast.error("One or more fields are missing for this line. Please check template.")
    }
  }

  const handleAddBulk = async (file) => {
    try {
      console.log(file.target.files[0]);
      if (/^.+\.csv$/.test(file.target.files[0].name)) {
        setBulkUsers([]);
        Papa.parse(file.target.files[0], {
          header: true, skipEmptyLines: true, comments: true, complete: function (result) {
            result.data.forEach((user) =>
              bulkAddUser(user)
            );
            newFirstName.value = "";
            newLastName.value = "";
            newEmail.value = "";
            setBulkAdd(true);
          }
        })
      } else {
        bulkCSV.value = "";
        setBulkAdd(false);
        setBulkUsers([]);
        toast.error("Uploaded file is invalid, please use the template.");
      }
    }
    catch (error) {
      console.log(error);
      bulkCSV.value = "";
      setBulkAdd(false);
      setBulkUsers([]);
      toast.error("Something went wrong trying to bulk-add users. Please check the template");
    }
  }

  const editUser = async () => {
    if (isEditing) return;
    if (selectedActiveUser.row.status != "Inactive") {
      if (editFirstName.value && editLastName.value && editEmail.value) {
        if (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(editEmail.value)) {
          setIsEditing(true);
          try {
            const editRequest = selectedActiveUser.row.status == "Active" ? "editUser" : "editWaitList"
            const response = await api.post(`${API_URL}/admin`, { request: editRequest, originalEmail: selectedActiveUser.row.email, email: editEmail.value, firstName: editFirstName.value, lastName: editLastName.value, role: editRole.value });

            if (response.data.result === 1) {
              editModal.style.display = "none";
              setSelectedActiveUser("");
              editFirstName.value = "";
              editLastName.value = "";
              toast.success("User details updated.");
              await populateData();
            }
            else if (response.data.result === -2) {
              toast.error("Invalid email address. This email cannot be used.");
            }
            else
              toast.error("There was an error trying to edit this user.");

          } catch (error) {
            toast.error("There was an error trying to edit this user. Operation cancelled.");
            console.log(error);
          } finally {
            setIsEditing(false);
          }
        } else {
          toast.error("Please enter a valid email address.");
        }
      }
    }
    else {
      editModal.style.display = "none";
      toast.error("This user is deactivated. Reactivate this user if you want to edit their information.")
    }
  }

  const addNewUser = async () => {
    if (isAdding) return;
    setIsAdding(true);
    if (bulkAdd) {
      try {
        for (const user of bulkUsers) {
          const response = await api.post(`${API_URL}/admin`, { request: 'addToWaitList', email: user.Email, firstName: user.FirstName, lastName: user.LastName, role: user.Role });
          if (response.data.result === 1) {
            toast.success(user.FirstName + " " + user.LastName + " successfully added to wait list.");
          } else if (response.data.result === -2) {
            toast.error(user.Email + " is already registered.");
          } else if (response.data.result === -3) {
            toast.error(user.Email + " is already in the waitlist.");
          } else {
            toast.error("There was an error trying to add " + user.FirstName + " " + user.LastName);
          }
        }
        addModal.style.display = "none";
        newFirstName.value = "";
        newLastName.value = "";
        newEmail.value = "";
        await populateData();

      } catch (error) {
        addModal.style.display = "none";
        newFirstName.value = "";
        newLastName.value = "";
        newEmail.value = "";

        toast.error("There was an error trying to bulk add users. Operation cancelled.");
        console.log(error);
      } finally {
        setIsAdding(false);
      }
    } else {
      if (newFirstName.value && newLastName.value && newEmail.value) {
        if (/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(newEmail.value)) {
          try {
            const response = await api.post(`${API_URL}/admin`, { request: 'addToWaitList', email: newEmail.value, firstName: newFirstName.value, lastName: newLastName.value, role: newRole.value });

            if (response.data.result === 1) {
              toast.success("User successfully added to wait list.");
              addModal.style.display = "none";
              newFirstName.value = "";
              newLastName.value = "";
              newEmail.value = "";
              await populateData();
            }
            else if (response.data.result === -2) {
              toast.error("This email is already registered/in use.");
            }
            else if (response.data.result === -3) {
              toast.error("This email is already in the waitlist.");
            }
            else
              toast.error("There was an error trying to add this user.");

          } catch (error) {
            toast.error("There was an error trying to add this user. Operation cancelled.");
            console.log(error);
          } finally {
            setIsAdding(false);
          }
        } else {
          toast.error("Please enter a valid email address.");
          setIsAdding(false);
        }
      } else {
        toast.error(`Please complete the form. Missing: ${newFirstName.value ? "" : (newLastName.value && newEmail.value) ? "First Name " : "First Name, "}
                    ${newLastName.value ? "" : newEmail.value ? "Last Name" : "Last Name, "}
                    ${newEmail.value ? "" : "Email"}`
        );
        setIsAdding(false);
      }
    }
  }

  const handleDeactivateUser = async () => {
    if (isDeactivating) return;
    if (selectedActiveUser.row.role === "Inactive") {
      toast.error("This user is already deactivated.");
    } else {
      setIsDeactivating(true);
      try {
        const response = await api.post(`${API_URL}/admin`, { request: 'suspendEmployee', employeeEmail: selectedActiveUser.row.email });

        if (response.data.result) {
          toast.success("User successfully deactivated.");
          await populateData();
        } else
          toast.error(
            "There was an error trying to deactivate this user. Operation cancelled."
          );
      } catch (error) {
        toast.error(
          "There was an error trying to deactivate this user. Operation cancelled."
        );
        console.log(error);
      } finally {
        setIsDeactivating(false);
      }
    }
  };

  const handleReactivateUser = async () => {
    if (isDeactivating) return;
    if (selectedActiveUser.row.role != "Inactive") {
      toast.error("This user is already active.");
    } else {
      setIsDeactivating(true);
      try {
        const response = await api.post(`${API_URL}/admin`, {
          request: "unsuspendEmployee",
          employeeEmail: selectedActiveUser.row.email,
        });

        if (response.data.result) {
          toast.success("User successfully reactivated.");
          await populateData();
        } else
          toast.error(
            "There was an error trying to reactivated this user. Operation cancelled."
          );
      } catch (error) {
        toast.error(
          "There was an error trying to reactivated this user. Operation cancelled."
        );
        console.log(error);
      } finally {
        setIsDeactivating(false);
      }
    }
  };

  const handleDeleteUser = async () => {
    if (isDeleting) return;
    setIsDeleting(true);
    try {
      const isWaitlistUser = selectedActiveUser.row.status === "Unregistered";
      const goal = isWaitlistUser ? "deleteWaitListUser" : "deleteUser";
      const response = await api.post(`${API_URL}/admin`, {
        request: goal,
        employeeEmail: selectedActiveUser.row.email,
      });

      if (response.data.result === 1) {
        toast.success("User successfully deleted.");
        setShowDeleteConfirm(false);
        setSelectedActiveUser("");
        await populateData();
      } else {
        toast.error("There was an error deleting this user. Operation cancelled.");
      }
    } catch (error) {
      toast.error("There was an error deleting this user. Operation cancelled.");
      console.log(error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleResendInvite = async () => {
    if (!selectedActiveUser || isResending) return;
    setIsResending(true);
    try {
      const response = await api.post(`${API_URL}/admin`, {
        request: "resendInviteEmail",
        employeeEmail: selectedActiveUser.row.email,
      });
      if (response.data.result === 1) {
        toast.success("Invitation email resent to " + selectedActiveUser.row.email);
      } else {
        toast.error("Failed to resend invitation. User may not be in the waitlist.");
      }
    } catch (error) {
      toast.error("Error resending invitation email.");
      console.log(error);
    } finally {
      setIsResending(false);
    }
  };

  function handleAddNewUser() {
    addModal.style.display = "flex";
  }

  // When the user clicks anywhere outside of the modal, close it
  // Disabled as per user request: only close when clicking the (X) button
  // window.onclick = function (event) {
  //   if (event.target == addModal) {
  //     addModal.style.display = "none";
  //   }
  //   if (event.target == editModal) {
  //     editModal.style.display = "none";
  //   }
  // };

  const populateData = async () => {
    setIsTableLoading(true);
    try {
      setUsers([]);
      setSelectedActiveUser("");
      setGridKey((prev) => prev + 1);
      setEntryList([]);
      const companyNameResponse = await api.post(`${API_URL}/admin`, {
        request: "getCompanyName",
      });
      if (companyNameResponse.data.result == 1) {
        const companyName = companyNameResponse.data.name;
        setCompanyName(companyName);
      }

      const companyEmployeeListResponse = await api.post(`${API_URL}/admin`, {
        request: "getUserList",
      });
      if (companyEmployeeListResponse.data.result == 1) {
        const employeeList = companyEmployeeListResponse.data.employeeDetails;

        const users = [];
        employeeList.forEach((employee) => {
          users.push(JSON.parse(employee));
        });

        setUsers(users);
      }

      const companyEmployeeEntryListResponse = await api.post(
        `${API_URL}/admin`,
        { request: "getUserWaitList" }
      );
      if (companyEmployeeEntryListResponse.data.result == 1) {
        const employeeEntryList =
          companyEmployeeEntryListResponse.data.employeeDetails;
        const entryUsers = [];
        employeeEntryList.forEach((entryEmployee) => {
          entryUsers.push(JSON.parse(entryEmployee));
        });

        setEntryList(entryUsers);
      }

      document.getElementById("adminIndexPage").className = "admin-index-page";
    } catch (error) {
      alert("Something went wrong, sending you to home page.");
      navigate("/home");
    } finally {
      setIsTableLoading(false);
    }
  };

  const handleModeChange = async (active) => {
    setActiveMode(active);
  };

  const user = useSelector((state) => state.auth.user);
  const isAdmin = isAdminUser(user);

  useEffect(() => {
    if (!isAdmin) {
      alert("You are not authorized to access this page");
      navigate("/home");
      return;
    }
    const role = user?.role || "Admin";
    setCurrentRole(role);
    if (role === "SuperUser") setIsSU(true);
    populateData();
  }, [isAdmin, user, navigate]);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="admin-index-page" id="adminIndexPage">
      <div className="sidebar">
        <SidebarCol />
      </div>
      <div className="admin-index-container-wrapper">
        <div className="header">
          <MainHeader
            titleText={`Administrator Portal`}
            subtitleText={"Expand Your Insight"}
          />
        </div>
        <div className="admin-index-content-container">
          <div className="admin-index-main-content-wrapper">
            <div className="admin-index-section">
              <div className="admin-index-section-subsection-container">
                <div className="admin-index-sub-text">Home</div>
                <div className="admin-index-separator">/</div>
                <div className="admin-index-sub-text">Admin</div>
                <div className="admin-index-separator">/</div>
                <div className="admin-index-main-text">User Management</div>
              </div>
            </div>
            <div className="admin-content-container-mobile">
              <div className="admin-content-section">
                <div className="admin-section-group-container">
                  <div className="admin-section-container">
                    <div className="admin-section-header-container">
                      <div className="admin-section-header">
                        <div className="admin-section-text-container">
                          <div className="admin-section-title">
                            User Management Unavailable on Mobile
                          </div>
                          <div className="admin-section-subtitle">
                            We're sorry, but the User Management page is
                            currently not supported on mobile devices. For the
                            best experience and full functionality, please
                            access this page from a desktop or laptop computer.
                            We're working on making this feature mobile-friendly
                            and appreciate your patience!
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="user-management-container">
              <div className="user-management-header">
                {companyName} - User Management
                <div className="user-management-button-container-add">
                  {(currentRole === "Admin" || currentRole === "SuperUser") && (
                    <div
                      className="user-management-button-green"
                      onClick={handleAddNewUser}
                    >
                      Add New User
                    </div>
                  )}
                </div>
              </div>
              <div
                className={
                  activeMode ? "user-management-table-active" : "admin-hidden"
                }
              >
                {users ? (
                  <Paper sx={{ height: "100%", width: "100%" }}>
                    <DataGrid
                      key={gridKey}
                      rows={users}
                      columns={columnsActive}
                      checkboxSelection
                      sx={{ border: 0 }}
                      rowSelectionModel={selectedActiveUser && selectedActiveUser.row && selectedActiveUser.row.id !== undefined ? { type: 'include', ids: new Set([selectedActiveUser.row.id]) } : { type: 'include', ids: new Set() }}
                      onRowSelectionModelChange={(newSelection) => {
                        const selectedIds = Array.isArray(newSelection)
                          ? newSelection
                          : (newSelection && newSelection.ids ? Array.from(newSelection.ids) : []);

                        if (selectedIds.length === 0) {
                          setSelectedActiveUser("");
                        } else {
                          // Enforce single selection: always take the last selected/checked item
                          const selectedId = selectedIds[selectedIds.length - 1];
                          const selectedRow = Array.isArray(users) ? users.find((u) => u.id === selectedId) : null;
                          if (selectedRow) {
                            setSelectedActiveUser({ row: selectedRow });
                          } else {
                            setSelectedActiveUser("");
                          }
                        }
                      }}
                      loading={isTableLoading}
                    />
                  </Paper>
                ) : (
                  <Paper sx={{ height: "100%", width: "100%" }}>
                    <DataGrid
                      rows={[]}
                      columns={columnsActive}
                      checkboxSelection
                      sx={{ border: 0 }}
                      loading={isTableLoading}
                    />
                  </Paper>
                )}
                <div className="user-management-button-container">
                  {/* Resend Invite — only for Unregistered (waitlist) users */}
                  <div
                    className={
                      selectedActiveUser &&
                      selectedActiveUser.row.status === "Unregistered" &&
                      (currentRole === "SuperUser" || currentRole === "Admin")
                        ? "user-management-button-white"
                        : "admin-hidden"
                    }
                    onClick={handleResendInvite}
                    style={{ opacity: isResending ? 0.7 : 1, pointerEvents: isResending ? 'none' : 'auto' }}
                  >
                    {isResending ? "Sending..." : "📧 Resend Invite"}
                  </div>
                  <div className={
                      selectedActiveUser &&
                      selectedActiveUser.row.role !== "SuperUser" &&
                      (currentRole === "SuperUser" || currentRole === "Admin")
                        ? "user-management-button-white"
                        : "admin-hidden"
                    } onClick={handleEditActive}>
                    Edit User
                  </div>
                  <div
                    className={
                      selectedActiveUser &&
                      selectedActiveUser.row.role !== "SuperUser" &&
                      selectedActiveUser.row.status === "Active" &&
                      (currentRole === "SuperUser" || currentRole === "Admin")
                        ? "user-management-button-red"
                        : "admin-hidden"
                    }
                    onClick={handleDeactivateUser}
                    style={{ opacity: isDeactivating ? 0.7 : 1, pointerEvents: isDeactivating ? 'none' : 'auto' }}
                  >
                    {isDeactivating ? "Loading..." : "Deactivate User"}
                  </div>
                  <div
                    className={
                      selectedActiveUser &&
                      selectedActiveUser.row.role === "Inactive" &&
                      (currentRole === "SuperUser" || currentRole === "Admin")
                        ? "user-management-button-green"
                        : "admin-hidden"
                    }
                    onClick={handleReactivateUser}
                    style={{ opacity: isDeactivating ? 0.7 : 1, pointerEvents: isDeactivating ? 'none' : 'auto' }}
                  >
                    {isDeactivating ? "Loading..." : "Reactivate User"}
                  </div>
                  <div
                    className={
                      selectedActiveUser &&
                      selectedActiveUser.row.role !== "SuperUser" &&
                      (currentRole === "SuperUser" || currentRole === "Admin")
                        ? "user-management-button-delete"
                        : "admin-hidden"
                    }
                    onClick={() => setShowDeleteConfirm(true)}
                  >
                    Delete User
                  </div>
                </div>
              </div>
            </div>
            <div className="user-management-modal-container" id="addModal">
              <div className="user-management-modal-body">
                <div className="user-management-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>Add New User</span>
                  <div
                    className="user-management-close-modal"
                    onClick={() => (addModal.style.display = "none")}
                    style={{ position: "static", marginLeft: "auto", marginRight: "12px", flexShrink: 0 }}
                  >
                    <FontAwesomeIcon icon={faX} />
                  </div>
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    First Name
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <input
                    class="user-management-input"
                    id="newFN"
                    type="text"
                    placeholder="Enter User's First Name"
                    disabled={bulkAdd}
                  />
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    Last Name
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <input
                    class="user-management-input"
                    id="newLN"
                    type="text"
                    placeholder="Enter User's Last Name"
                    disabled={bulkAdd}
                  />
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    Email Address
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <input
                    class="user-management-input"
                    id="newEmail"
                    type="text"
                    placeholder="Enter User's Email Address"
                    disabled={bulkAdd}
                  />
                </div>
                <div
                  className="user-management-input-form-container"
                  style={{ display: (currentRole === "Admin" || currentRole === "SuperUser") ? "flex" : "none" }}
                >
                  <div className="user-management-input-header">
                    Role
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <select
                    id="newRole"
                    type="text"
                    defaultValue={"Employee"}
                    placeholder="Select User's Role"
                    disabled={bulkAdd}
                  >
                    <option value="Employee">Employee</option>
                    <option value="Admin">Admin</option>
                    {currentRole === "SuperUser" && (
                      <option value="SuperUser">SuperUser</option>
                    )}
                  </select>
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    Bulk Add (Use Template)
                  </div>
                  <div className="user-management-file-input-container">
                    <input
                      id="bulkCSV"
                      class="user-management-input"
                      type="file"
                      accept=".csv"
                      onChange={handleAddBulk}
                    />
                    <FontAwesomeIcon
                      onClick={handleRemoveTemplate}
                      icon={faX}
                      className="user-management-file-input-close"
                      style={{ display: bulkAdd ? "block" : "none" }}
                    />
                  </div>
                </div>
                <div
                  className="user-management-button-green"
                  onClick={addNewUser}
                  style={{ opacity: isAdding ? 0.7 : 1, pointerEvents: isAdding ? 'none' : 'auto' }}
                >
                  {isAdding ? (
                    <p>Loading...</p>
                  ) : (
                    <>
                      <p style={{ display: bulkAdd ? "none" : "flex" }}>Add User</p>
                      <p style={{ display: bulkAdd ? "flex" : "none" }}>
                        Bulk Add User(s)
                      </p>
                    </>
                  )}
                </div>
                <a
                  href="/MindsherpaBulkEmployeeTemplate.csv"
                  download="MindsherpaBulkEmployeeTemplate.csv"
                  className="user-management-button-white"
                >
                  Download Template
                </a>
              </div>
            </div>
            <div className="user-management-modal-container" id="editModal">
              <div className="user-management-modal-body" style={{ height: "65vh" }}>
                <div className="user-management-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <span style={{ marginRight: "24px", wordBreak: "break-word" }}>
                    Editing User - {selectedActiveUser ? selectedActiveUser.row.firstname + " " + selectedActiveUser.row.lastname : ""}
                  </span>
                  <div 
                    className="user-management-close-modal" 
                    onClick={() => (editModal.style.display = "none")}
                    style={{ position: "static", marginLeft: "auto", marginRight: "12px", flexShrink: 0, marginTop: "4px" }}
                  >
                    <FontAwesomeIcon icon={faX} />
                  </div>
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    First Name
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <input class="user-management-input" id="editFN" type="text" placeholder="Enter User's First Name" defaultValue={selectedActiveUser ? selectedActiveUser.row.firstname : ""} />
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    Last Name
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <input class="user-management-input" id="editLN" type="text" placeholder="Enter User's Last Name" defaultValue={selectedActiveUser ? selectedActiveUser.row.lastname : ""} />
                </div>
                <div className="user-management-input-form-container">
                  <div className="user-management-input-header">
                    Email Address
                  </div>
                  <input style={{ background: "#e3dedeff" }} class="user-management-input" id="editEmail" type="text" placeholder="Enter User's Email Address" defaultValue={selectedActiveUser ? selectedActiveUser.row.email : ""} disabled />
                </div>
                <div className="user-management-input-form-container" style={{ display: (currentRole === "Admin" || currentRole === "SuperUser") ? "flex" : "none" }}>
                  <div className="user-management-input-header">
                    Role
                    <span style={{ color: "red" }}>*</span>
                  </div>
                  <select id="editRole" type="text" placeholder="Select User's Role">
                    <option value="Employee" selected={selectedActiveUser && selectedActiveUser.row.role === "Employee"}>Employee</option>
                    <option value="Admin" selected={selectedActiveUser && selectedActiveUser.row.role === "Admin"}>Admin</option>
                    {currentRole === "SuperUser" && (
                      <option value="SuperUser" selected={selectedActiveUser && selectedActiveUser.row.role === "SuperUser"}>SuperUser</option>
                    )}
                  </select>
                </div>
                <div
                  className="user-management-button-green"
                  onClick={editUser}
                  style={{ opacity: isEditing ? 0.7 : 1, pointerEvents: isEditing ? 'none' : 'auto' }}
                >
                  <p>{isEditing ? "Loading..." : "Save Changes"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="user-management-modal-container" style={{ display: "flex" }}>
          <div className="user-management-modal-body" style={{ maxWidth: "420px", gap: "0" }}>

            {/* Header */}
            <div className="user-management-header">
              Delete User
              <div
                className="user-management-close-modal"
                onClick={() => setShowDeleteConfirm(false)}
                style={{ position: "static", marginLeft: "auto", marginRight: "12px" }}
              >
                <FontAwesomeIcon icon={faX} />
              </div>
            </div>

            {/* User info card */}
            <div style={{ margin: "16px 0", padding: "14px 16px", background: "#f8f8f8", borderRadius: "8px", border: "1px solid #eee", display: "flex", alignItems: "center", gap: "14px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "#fde8e8", color: "#8f0c0c", fontWeight: "700", fontSize: "16px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, textTransform: "uppercase" }}>
                {(selectedActiveUser?.row?.firstname?.[0] ?? "") + (selectedActiveUser?.row?.lastname?.[0] ?? "")}
              </div>
              <div style={{ minWidth: 0 }}>
                <p style={{ margin: 0, fontWeight: "600", fontSize: "14px", color: "#1a1a1a" }}>
                  {selectedActiveUser?.row?.firstname} {selectedActiveUser?.row?.lastname}
                </p>
                <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#666", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {selectedActiveUser?.row?.email}
                </p>
                <span style={{ display: "inline-block", marginTop: "4px", fontSize: "11px", padding: "2px 8px", borderRadius: "999px", background: "#e5e5e5", color: "#555", fontWeight: "500" }}>
                  {selectedActiveUser?.row?.role}
                </span>
              </div>
            </div>

            {/* Warning */}
            <div style={{ display: "flex", gap: "10px", alignItems: "flex-start", background: "#fff5f5", border: "1px solid #fbc5c5", borderRadius: "8px", padding: "12px 14px", marginBottom: "20px" }}>
              <span style={{ fontSize: "16px", flexShrink: 0 }}>⚠️</span>
              <div>
                <p style={{ margin: 0, fontSize: "13px", fontWeight: "600", color: "#8f0c0c" }}>This action cannot be undone</p>
                <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#b00020" }}>All account data, history and settings for this user will be permanently removed.</p>
              </div>
            </div>

            {/* Buttons */}
            <div style={{ display: "flex", gap: "12px" }}>
              <div
                className="user-management-button-white"
                onClick={() => setShowDeleteConfirm(false)}
                style={{ flex: 1, justifyContent: "center" }}
              >
                Cancel
              </div>
              <div
                className="user-management-button-delete"
                onClick={handleDeleteUser}
                style={{ flex: 1, justifyContent: "center", opacity: isDeleting ? 0.7 : 1, pointerEvents: isDeleting ? "none" : "auto" }}
              >
                {isDeleting ? "Deleting..." : "Delete User"}
              </div>
            </div>

          </div>
        </div>
      )}
    </div>
  );
};
